import React, { useEffect } from 'react';

const LiveChat = () => {
  useEffect(() => {
    // Define the Connex One live chat hooks
    window.__CONNEXONE_LIVECHAT_HOOKS__ = {
      onLoad: function () {
        console.log('Connex One live chat loaded');
      },
    };

    // Load the live chat script
    const script = document.createElement('script');
    script.src = 'https://livechat-nlpcpensionfundadministrators.connexone.co.uk/widget?connid=afb7e249-0d8e-4b4e-95c7-a4558c27fb62';
    script.id = 'livechat-nlpcpensionfundadministrators';
    script.setAttribute('data-socket-uri', 'https://livechat-nlpcpensionfundadministrators.connexone.co.uk');

    // Append the script to the document
    document.body.appendChild(script);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div className="live-chat-container"></div>;
};

export default LiveChat;
